import styled, { css } from 'styled-components';
import { Icon } from '@iconify/react';

type TagProps = {
  full?: boolean;
  variant: 'primary' | 'danger' | 'warning' | 'positive' | 'neutral';
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Tag = styled.div<TagProps>`
  width: ${({ full }) => (full ? '100%' : 'fit-content')};;
  height: fit-content;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;

  border-radius: 40px;
  padding: 4px;
  padding-inline: 10px;
  font-weight: 700;

  ${({ variant }) =>
    variant === 'primary' &&
    css`
      background-color: #9EEAFF;
      ;
      color: ${props => props.theme.colors.primary};

    `}
    ${({ variant }) =>
    variant === 'positive' &&
    css`
      background-color: #BAF5C5;
      color: #008826;
    
    `}
    ${({ variant }) =>
    variant === 'warning' &&
    css`
      background-color: #FFDE9E;
      color: #F07300;
    
    `}
    ${({ variant }) =>
    variant === 'danger' &&
    css`
      background-color: #FF7373;
      color: #DF0000;
    `}
    ${({ variant }) =>
    variant === 'neutral' &&
    css`
        background-color: #F3F4F6;
        color: #6B7280;
      `}
`;

export const TagIcon = styled(Icon)`
  cursor: pointer;
`;
